import React from 'react';

import { SvgIconOwnProps } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

import classes from './GeneralScoreInfo.module.scss';

type GeneralScoreInfoProps = {
  title: string;
  value: number;
  color: SvgIconOwnProps['color'];
  dataTestId: string;
};

const GeneralScoreInfo = ({ title, value, color, dataTestId }: GeneralScoreInfoProps) => {
  return (
    <div>
      <h5 className={classes.title}>{title}</h5>
      <div className={classes.box}>
        <CircleIcon className={classes.icon} color={color} />
        <span className={classes.value} data-test-id={dataTestId}>
          {value}
        </span>
      </div>
    </div>
  );
};

export { GeneralScoreInfo };
